<template>
  <div class="container">
    <h1 style="text-align: center;">
      Not Allowed
    </h1>
  </div>
</template>

<script>

export default {
  name: 'NotAllowed',
};
</script>



// WEBPACK FOOTER //
// src/views/not_allowed/NotAllowed.vue